import React from 'react';
import { useNavigate } from 'react-router-dom';
import BusinessForm from '../../components/BusinessForm';
import { api } from '../../lib/api';

export default function EmployeeAddListing() {
  const nav = useNavigate();
  const onSubmit = async (payload) => {
    await api.post('/employee/businesses', payload);
    // log activity
    api.post('/employee/activity', { action: 'created_business', entity_type: 'business', notes: payload.name }).catch(()=>{});
    nav('/employee/listings');
  };
  return (
    <div data-testid="employee-add">
      <h2 className="mb-3">Add new listing</h2>
      <div className="ap-card">
        <BusinessForm onSubmit={onSubmit} submitLabel="Create listing" />
      </div>
    </div>
  );
}
